import CompLayout from "@/pcomponents/comp/layout/layout";
import MonthListArea from "@/pages/comp/plan/todo_dailyc/common/month_list";

function TodoDailyCMonthListPage() {

  return (
    <CompLayout>
      <MonthListArea></MonthListArea>
    </CompLayout>
  );
}

export default TodoDailyCMonthListPage;